<template>
  <div>

      <h5>レビュー管理</h5>
      <div class="row">
        <div class="col-md-6">
          <label for="status" class="d-block col-form-label">検索ワード:</label>
          <input type="text" v-model="searchForm.freeword" value="">
        </div>
        <div class="col-md-6">
          <label for="status" class="d-block col-form-label">販売者ID:</label>
          <input type="text" v-model="searchForm.id" value="">
        </div>
        <div class="col-md-6">
          <a class="btn btn-info" style="margin-top: 37px;" href="javascript:void(0);" @click="get_reviews">検索</a>
        </div>
      </div>
      <hr>

      <div class="py-3 contents">
        <div class="table-responsive">
          <table class="table">
            <tr>
              <th style="min-width: 150px;">日時</th>
              <th style="min-width: 150px;">種別</th>
              <th style="min-width: 150px;">評価コメント</th>
              <th style="min-width: 150px;">返信コメント</th>
              <th style="min-width: 150px;">詳細</th>
            </tr>
            <tr v-for="(review, index) in allGetReviews">
              <td>
                {{ convert_jst_for_message(review['review']['created_at']) }}
              </td>
              <td>
                {{ get_hash_value(type, review['review']['type']) }}
              </td>
              <td>
                <span>{{ cinit(review['review']['contents'], '-') }}</span>
              </td>
              <td>
                <span>{{ cinit(review['review']['review_comments_contents'], '-') }}</span>
              </td>
              <td>
                <button class="btn btn-info" @click="jumpReview(review['review']['orders_id'])">詳細</button>
              </td>
            </tr>
          </table>
        </div>
      </div>

  </div>
</template>

<script>
export default {
  props: { 
    user: Object
  },
  data() {
		const type = [
      {"no":"1","name":"商品"},
      {"no":"2","name":"販売者"},
    ];
    return {
      reviews: [],
      type,
      searchForm: {
        id: "",
        freeword: "",
      },
    }
  },
	methods: {
    jumpReview: function(id){
      window.open('/admin/order/'+String(id), '_blank')
      // this.$router.push({path: '/admin/order/'+String(id)});
      return false;
	  },
	  async get_reviews() {
		  this.$store.dispatch('product/get_reviews', {
        searchForm: this.searchForm,
      }).then(res => {
		    console.log(res);
		    let ret = res.data;
        let new_reviews = [];
		    this.reviews = ret['reviews'];
        for (let i = 0; i < this.reviews.length; i++) {
          if ( this.reviews[i]['review']['review_comments_del_flg'] != 0 ) {
            this.reviews[i]['review']['review_comments_contents'] = '';
          }
          if ( this.cinit(this.searchForm.id, '') != "" && String(this.cinit(this.searchForm.id, '')) != String(this.reviews[i]['review']['sellers_id']) ) {
            continue;
          }
          if ( this.cinit(this.searchForm.freeword, '') != "" ) {
            if ( String(this.reviews[i]['review']['contents']).indexOf(this.searchForm.freeword) < 0 && String(this.reviews[i]['review']['review_comments_contents']).indexOf(this.searchForm.freeword) < 0 ) {
              continue;
            }
          }
          new_reviews.push(this.reviews[i]);
        }
        this.reviews = new_reviews;
		    // console.log(this.reviews);
		  }, error => {
		    console.log('error発生');
		    console.log(error);
		    this.$nextTick(() => {
          window.scrollTo({
            top: 0,
          });
		    });
  	  });
	  },
  },
	created() {
		this.get_reviews();
	},
	computed: {
		allGetReviews: function() {
			return this.reviews;
		},
	},
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/mypage/admin/review.vue